// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".contract-history-wrapper .contract-btn[data-v-4908d49c]:not(:last-child){margin-bottom:10px}", ""]);
// Exports
module.exports = exports;
